import React from "react";

const UserManualPage: React.FC = () => {
  return (
    <main className="flex-grow p-4">
      <div className="bg-white shadow-xl rounded-lg overflow-hidden">
        <div className="w-full" style={{ height: "calc(100vh - 180px)" }}>
          <iframe
            title="QBA User Manual"
            src="/QBA_User_Manual/QBA_User_Manual.html"
            className="w-full h-full border-0"
          />
        </div>
      </div>
    </main>
  );
};

export default UserManualPage;
